import { Check, ErrorOutline } from '@mui/icons-material';

export const iconMapper = {
  open: <ErrorOutline />,
  resolved: <Check />,
};
